
import axios from 'axios'

const settings = {
    state: {
        theme: localStorage.getItem('theme-stale') || false,
    },
    actions: {
        async A_SET_THEME ({ commit }, payload) {
            commit('M_SET_THEME', payload)
        },

    },
    mutations: {
        M_SET_THEME (state, payload) {
            state.theme = payload
            localStorage.setItem('theme-stale', payload)
        },
    },
    getters: {
        GET_STATUS_THEME: state => { return state.theme },

    }
}

export default settings
